export var TelemetryType={log:"log",configuration:"configuration",usage:"usage"};